export default "__VITE_ASSET__CHWanspg__"